const footerLinks = [
  { href: "#schedule", label: "新番时间表" },
  { href: "#recommend", label: "追番推荐" },
  { href: "#updates", label: "动画更新" },
  { href: "#classics", label: "经典回顾" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-background-800 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">51动漫网</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              一站式追番资讯站点，为你提供新番时间表、追番推荐与动画更新动态，满足每一位动漫爱好者的追更需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-8 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <a href="mailto:contact@51-dongman.example" className="hover:text-primary-400">
                  contact@51-dongman.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-message-3-line text-primary-400"></i>
                客服在线时间 9:00 - 21:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-700 pt-6 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 51动漫网 · 新番时间表 / 4月新番推荐 / 动画更新同步
          </p>
          <p className="text-xs text-background-400">
            <i className="ri-heart-line mr-1 text-primary-400"></i>
            只为热爱动画的你
          </p>
        </div>
      </div>
    </footer>
  );
}